import { create } from 'zustand';

/**
 * Groupes de packs sélectionnés dans l'espace Configuration.
 *
 * Multi-sélection : on peut afficher le contenu de tous les groupes, d'un seul, ou de plusieurs.
 * Partagé entre les pages Blocks / Items / Entities / Crafts, ce qui permet de garder son filtre en
 * naviguant de l'une à l'autre.
 *
 * DÉLIBÉRÉMENT NON PERSISTÉ. La sélection l'était, et un filtre posé une fois survivait à toutes les
 * sessions suivantes : le staff rouvrait le panel des semaines plus tard avec une partie du contenu
 * invisible, sans se souvenir d'avoir filtré. Chaque session repart donc de « tous cochés », sauf
 * le groupe Vanilla, décoché par défaut (voir ConfigCatalog).
 */
interface ConfigGroupState {
  selectedGroupIds: string[];
  setSelectedGroupIds: (ids: string[]) => void;
}

export const useConfigGroupStore = create<ConfigGroupState>((set) => ({
  selectedGroupIds: [],
  setSelectedGroupIds: (selectedGroupIds) => set({ selectedGroupIds }),
}));
